module.exports = __webpack_public_path__ + "img/link-icon.d3d98e8b.svg";